'use client';

import vigijobsLogo from '@/assets/logos/partners/vigijobs-colored.svg';
import { Trans, t } from '@lingui/macro';
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '@prismo-io/design-system';
import Image from 'next/image';
import Link from 'next/link';
import type { FC } from 'react';
type Props = {
  order: number;
};
export const VigijobsCard: FC<Props> = (props: Props) => {
  const {
    order
  } = props;
  return <Stack component="article" bgcolor="background.paper"
  // bgcolor="background.primary"
  borderRadius="3rem" p={2} zIndex={10} minWidth={{
    none: '100%',
    sm: '45%',
    lg: '31%'
  }} sx={{
    boxShadow: '2px 2px 7px 0px rgba(0,0,0,0.3)',
    flex: '1 1 0%',
    order: order
  }} direction="column" alignItems="center" spacing={2} data-sentry-element="Stack" data-sentry-component="VigijobsCard" data-sentry-source-file="index.tsx">
      <Box component="div" position="relative" width="10.5rem" height="10.5rem" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Image src={vigijobsLogo} alt="" style={{
        objectFit: 'contain',
        objectPosition: 'center'
      }} fill data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      </Box>
      <Typography textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">
          Trouvez et surveillez les nouvelles offres de plus de 2600 sites
          emploi avec une seule application !
        </Trans>
      </Typography>
      <Box component="div" display={{
      none: 'block',
      md: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Link href={'https://app.adjust.com/12lqt3p3'} passHref legacyBehavior target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
          <Button variant="text" color="inherit" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">Je télécharge l’app !</Trans>
          </Button>
        </Link>
      </Box>
      <Box component="div" display={{
      none: 'none',
      md: 'block'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Link href={'https://www.vigijobs.fr/?utm_source=parcours_utilisateur_prismo'} passHref legacyBehavior target="_blank" data-sentry-element="Link" data-sentry-source-file="index.tsx">
          <Button variant="text" color="inherit" data-sentry-element="Button" data-sentry-source-file="index.tsx">
            <Trans data-sentry-element="Trans" data-sentry-source-file="index.tsx">En savoir plus</Trans>
          </Button>
        </Link>
      </Box>
    </Stack>;
};